import * as React from 'react';

/* Gjensidige Core 30 Imports */
import { Text, Title } from '@gjensidige/nci-core-typography';
import { Modal } from '@gjensidige/core-modal/lib/modal';

export interface Props {
  showModal: boolean;
  toggleModal: () => void;
}

const PurchaseConditionsModal: React.FC<Props> = ({
  showModal,
  toggleModal
}) => {
  return (
    <Modal
      ariaLabel="modal"
      ariaLabelCloseButton="Close modal"
      visible={showModal}
      closable
      onClick={toggleModal}
    >
      <div data-testid="content">
        <Title tag="h3">Betingelser for køb online</Title>
        <br />
        <Title tag="h5">Præmisser for købet</Title>
        <Text>
          For at opnå samlerabat er det en forudsætning, at du har mindst 3
          forskellige af følgende privatforsikringer i Gjensidige Forsikring:
          bil-, hus-, fritidshus-, indbo-, ejerskifte- eller ulykkesforsikring.
          Med en landbrugsforsikring, kræver det kun én ekstra forsikring for at
          opnå samlerabat.
          <br />
          <br />
          Træder forsikringen i kraft efter årsskiftet, vil præmier,
          selvrisikobeløb og forsikringssummer blive indeksreguleret.
        </Text>
        <br />
        <Title tag="h5">Bonus fra tidligere forsikringsselskab</Title>
        <Text>
          Skal vi overføre bonus på bil eller motorcykel fra dit tidligere
          forsikringsselskab, vil prisen på din nye bil- eller
          motorcykelforsikring være endeligt gældende, så snart vi får
          bekræftet, at antal skadefri år er korrekte. Hvis vi får nye
          oplysninger og derfor må justere forsikringstilbuddet, informerer vi
          dig med det samme, og du vil få tilsendt en ny police med en justeret
          pris
        </Text>
        <br />
        <Title tag="h5">Samtykke</Title>
        <Text>
          Med din accept giver du samtykke til, at vi må indhente alle relevante
          kundeoplysninger - dog ikke helbredsoplysninger eller oplysninger om
          rent private forhold - hos tidligere forsikringsselskab(er) om dine og
          din husstands forsikringsforhold i forbindelse med indtegning og
          skader, samt at vi må opsige dine/jeres forsikringer i tidligere
          forsikringsselskab(er).
          <br />
          <br />
          Der gives samtykke til at indhente oplysninger om følgende:
          <br />
          <br />
        </Text>
        <ul>
          <li>årsag til opsigelse i tidligere forsikringsselskab</li>
          <li>
            opsigelsesdato (ophørsdato i nuværende/tidligere forsikringsselskab)
          </li>
          <li>
            skadesforløb (antal skader, skadernes størrelse, art og skadedato)
          </li>
          <li>antal skadefri år (bonustrin)</li>
          <li>skærpede vilkår</li>
        </ul>
        <Text>
          Der gives desuden samtykke til at indhente oplysninger i det Digitale
          Motor Register (DMR)
        </Text>
        <br />
        <Title tag="h5">Erklæring</Title>
        <Text>
          Du erklærer med din accept, at du har svaret korrekt på alle
          spørgsmål, at de allerede nævnte forudsætninger og nedenstående krav
          er i overensstemmelse med de faktiske forhold. Er det modsatte
          tilfældet, kan det få konsekvenser for din erstatning, eller medføre
          at din forsikring/dine forsikringer slettes.
          <br />
          <br />
          Det er et krav for tegning, at du eller andre medlemmer af husstanden
          ikke:
          <br />
          <br />
        </Text>
        <ul>
          <li>
            er registreret i Experians RKI-register eller andet debitorregister
          </li>
          <li>er under konkurs eller konkursbehandling</li>
          <li>er i restance i nuværende forsikringsselskab</li>
          <li>
            er adviseret om eller har fået skærpede vilkår efter en skade fx
            forhøjet præmie og/eller påtvungen selvrisiko inden for de sidste 3
            år
          </li>
          <li>
            er adviseret om, eller har modtaget meddelelse om, at en forsikring
            vil ophøre, blive opsagt, slettet, eller annulleret, i et andet
            selskab pga. en skade, urigtige risikooplysninger eller manglende
            betaling inden for de sidste 3 år
          </li>
          <li>
            har anmeldt mere end tre skader på én forsikring inden for de sidste
            3 år, uanset om denne har været i flere selskaber. Ved én forsikring
            forstås samme forsikringstype fx indboforsikring, husforsikring og
            bilforsikring
          </li>
        </ul>
        <Title tag="h5">
          e-Boks og elektronisk kommunikation i det løbende kundeforhold
        </Title>
        <Text>
          Ved indgåelse af denne aftale kan vi i det løbende kundeforhold sende
          breve til dig i din e-Boks i henhold til reglerne for god skik i den
          finansielle sektor. Det betyder, at du som udgangspunkt ikke længere
          modtager breve fra os på papir, og vi fremadrettet bestræber os på at
          sende de fleste breve i din e-Boks. Vi udveksler dit CPR-nr. med
          e-Boks med henblik på korrekt identifikation af dig i forbindelse med
          anvendelse af e-Boks.
          <br />
          <br />
          Hvis du ikke ønsker at modtage post i din e-Boks fra os, kan du dog
          til enhver tid fravælge dette på e-Boks.dk eller ved at kontakte os.
          <br />
          <br />
          Du har selv ansvaret for, at dine breve i e-Boks bliver åbnet og
          kontrolleret på samme måde, som hvis du havde modtaget dem på papir.
          <br />
          <br />
          Der kan også forekomme information eller kommunikation via mail,
          telefon og SMS og selvbetjeningsfunktionen på vores indbomeside.
        </Text>
      </div>
    </Modal>
  );
};

export default PurchaseConditionsModal;
